import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { SurveyMessages } from 'src/app/common-class/survey-messages';

@Component({
  selector: 'app-drill-down',
  templateUrl: './drill-down.component.html',
  styleUrls: ['./drill-down.component.css'],
})
export class DrillDownComponent implements OnInit {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() matrix: Matrix;
  @Input() isMobile: boolean;
  @Input() DropDown: string;
  @Input() isNewParticipationButton: boolean;
  @Input() isShowHiddenQN: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;

  tempArray = [];
  questionsArray: any;
  checkDrillDown: number = 0;
  prevValue: any;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean = false;
  surveyMessages: SurveyMessages;
  isNewParticipation: boolean;
  surveyFormat: number = 0;
  newParticipationBtnText: string;
  isAnsChange: boolean = false;
  resetPageSub: any;
  isEditPostPop: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['JsonData'];
    if (change != null && change != undefined) {
      const curVal = JSON.stringify(change.currentValue);
      const preVal = JSON.stringify(change.previousValue);
      if (curVal != preVal && preVal != undefined) {
        this.questions = JSON.parse(this.JsonData);
        this.onLoadValue();
        this.ngAfterViewInit();
      }
    }
  }

  constructor(private service: ParticipationDataService) { }

  ngOnInit() {
    if (this.questions == null) {
      this.surveyMessages = this.service.getSurveyMessages();
      this.isEditPostPop = this.service.getisEditPostPop();
        this.questions = JSON.parse(this.JsonData);
      let imgQn = this.questions?.find((e) => e.sub_qno == 1);
      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }
      for (let i = 0; i < this.questions?.length; i++) {
        if (this.questions[i].answer_style == 1 && this.questions[i].Answers != null) {
          this.questions[i].Answers = CommonLogic.RandomAnswerHandling(this.questions[i]);
        }
      }
      if (this.group?.answer_style == 0 && this.questions.length > 1) {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      }
      this.onLoadValue();
    }
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
  }

  onLoadValue() {
    for (let i = 0; i < this.questions?.length; i++) {
      if (this.questions[i].selectAnsValue == undefined) {
        this.questions[i].selectAnsValue = 0;
      } else if (this.questions[i].selectAnsValue > 0) {
        this.checkDrillDown = 1;
      } else if (this.questions[i].selectAnsValue == -1) {
        this.questions[i].selectAnsValue = 0;
      }
    }
  }

  ngAfterViewInit() {
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });
  }

  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  SelectedValue(answer: any, question: Questions, index: number) {
    this.isAnsChange = true;
    if (answer === '0') {
      this.ResetControl(index);
      return;
    } else {
      for (const answerItem of question.Answers) {
        if (answer == answerItem.value_id) {
          if (question.isLoading) {
            this.ResetControl(index + 1);
          }
          answerItem.selectdId = 1;
          question.AnswerID = answerItem.ms_id;
          question.selectAnsValue = answerItem.value_id;
          question.AnswerText = answerItem.value_text;
          question.pageto = answerItem.pageto;
          question.otherAnswer = null;
          question.isLoading = true;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answerItem.isOther) {
            question.isOtherAnswer = true;
          } else {
            question.isOtherAnswer = false;
          }
        } else {
          answerItem.ControlAns = null;
          answerItem.selectdId = 0;
        }
      }
    }

    this.ChangeAnswersData.emit(question);

  }

  ResetControl(index: number) {
  for (let i = index; i < this.questions.length; i++) {
    const question = this.questions[i];
    if (question.isLoading) {
      question.selectAnsValue = 0;
      question.isOtherAnswer = false;
      question.AnswerID = 0;
      question.AnswerText = null;
      question.isLoading = false;
      this.ChangeAnswersData.emit(question);
    }
  }
}

  GetSelectedAnswer(index: number, question: Questions): Answers[] {
    if (index == 0) {
      return question.Answers;
    } else if (index > 0) {
      if (this.questions[index - 1].selectAnsValue > 0) {
        return question.Answers.filter((e) => e.ParentMsId == this.questions[index - 1].AnswerID);
      } else {
        return [];
      }
    }
    return [];
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  setDrillDownValue(valueId: any, question: Questions, index: number, self) {
    self.SelectedValue(valueId, question, index);
  }

  showDDList(event) {
    const drillDownSearch = event.target.closest('.drill-down-search');
    const drillDownInput = event.target.closest('.drill-down-input');
    if (drillDownSearch.classList.contains('showDrillList')) {
      drillDownSearch.classList.remove('showDrillList'); 
      drillDownInput.attr('aria-expanded', 'false');
    } else {
      document.querySelectorAll('.drill-down-search').forEach((el) => el.classList.remove('showDrillList'));
      drillDownSearch.classList.add('showDrillList');
      drillDownSearch.querySelector('.drill-down-input').focus(); 
      drillDownSearch.querySelectorAll('.drill-down-list-item').forEach((item) => {
        item.style.display = 'block'; 
      });
    }
  }

  selectDDListItem(event, question: Questions, index: number) {
    const drillDownSearch = event.target.closest('.drill-down-search');
    drillDownSearch.querySelector('.drill-down-input').value = '';
    drillDownSearch.querySelectorAll('.drill-down-list-item').forEach((item) => {
      item.innerHTML = item.getAttribute('ogListValue'); 
      item.style.display = 'block'; 
      item.innerHTML = this.highlight(item.innerHTML, '');
    });
    const itemText = event.target.getAttribute('ogListValue'); 
    const itemValue = event.target.getAttribute('list-value'); 
    drillDownSearch.querySelector('select').value = itemValue;
    drillDownSearch.querySelector('.drill-down-input').value = itemText;
    drillDownSearch.classList.remove('showDrillList'); 
    this.checkDrillDown = 1;
    this.setDrillDownValue(itemValue, question, index, this);
  }

  setDDListItem(event, question: Questions, index: number) {
    setTimeout(() => {
      if (this.checkDrillDown === 0 && this.checkDrillDown !== undefined) {
        const ddSearchValue = event.target.value.toLowerCase();
        if (ddSearchValue !== '') {
          const drillDownSearch = event.target.closest('.drill-down-search'); 
          const drillDownListItems = drillDownSearch.querySelectorAll('.drill-down-list-item'); 
          drillDownListItems.forEach((item) => {
            item.innerHTML = item.getAttribute('ogListValue'); 
            if (ddSearchValue === item.textContent.toLowerCase()) { 
              event.target.value = item.getAttribute('ogListValue');
              const itemValue = item.getAttribute('list-value'); 
              drillDownSearch.querySelector('select').value = itemValue; 
              this.setDrillDownValue(itemValue, question, index, this);
              return;
            } else {
              event.target.value = ''; 
              drillDownSearch.querySelector('select').value = '0';
              question.AnswerText = null;
              this.setDrillDownValue('0', question, index, this);
            }
          });

        }
        else {
          question.AnswerText = null;
          this.setDrillDownValue('0', question, index, this);
        }
      }

    }, 0);

  }

  filterDDSearch(event) {
    const keyCode = event.keyCode || event.which;
  
    // Handle Enter key or undefined keyCode
    if (keyCode === 13 || keyCode === undefined) {
      event.preventDefault();
      event.target.blur();
  
      setTimeout(() => {
        const drillDownSearch = event.target.closest('.drill-down-search');
        if (drillDownSearch) {
          drillDownSearch.classList.remove('showDrillList');
        }
      }, 100);
    }
  
    setTimeout(() => {
      if (keyCode !== 9) {
        const drillDownSearch = event.target.closest('.drill-down-search');
        drillDownSearch.classList.add('showDrillList');
  
        // Handle Down Arrow key (keyCode 40)
        if (keyCode === 40) {
          event.preventDefault();
  
          const selectElement = drillDownSearch.querySelector('select');
          const visibleItems = Array.from(
            drillDownSearch.querySelectorAll('.drill-down-list .drill-down-list-item') as NodeListOf<HTMLElement>
          ).filter((item) => item.offsetParent !== null);
  
          if (
            selectElement.value <= 0 ||
            selectElement.value === visibleItems[visibleItems.length - 1]?.getAttribute('list-value')
          ) {
            const firstVisibleItem = visibleItems[0];
            selectElement.value = firstVisibleItem?.getAttribute('list-value') || '0';
            drillDownSearch.querySelector('.currentActiveDDITem')?.classList.remove('currentActiveDDITem');
            firstVisibleItem?.classList.add('currentActiveDDITem');
            event.target.value = selectElement.options[selectElement.selectedIndex]?.text || '';
          } else {
            const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
            const nextVisibleItem = currentActiveItem?.nextElementSibling;
  
            if (nextVisibleItem && nextVisibleItem.offsetParent !== null) {
              selectElement.value = nextVisibleItem.getAttribute('list-value');
              event.target.value = selectElement.options[selectElement.selectedIndex]?.text || '';
              currentActiveItem?.classList.remove('currentActiveDDITem');
              nextVisibleItem.classList.add('currentActiveDDITem');
            } else {
              const lastActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
              selectElement.value = lastActiveItem?.getAttribute('list-value') || '0';
              event.target.value = selectElement.options[selectElement.selectedIndex]?.text || '';
              lastActiveItem?.classList.remove('currentActiveDDITem');
              lastActiveItem?.classList.add('currentActiveDDITem');
            }
          }
  
          // Scroll handling
          const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
          const listContainer = drillDownSearch.querySelector('.drill-down-list');
          if (currentActiveItem && listContainer) {
            const itemTop = currentActiveItem.getBoundingClientRect().top;
            const itemBottom = itemTop + currentActiveItem.offsetHeight;
            const containerTop = listContainer.getBoundingClientRect().top;
            const containerBottom = containerTop + listContainer.offsetHeight;
  
            if (itemBottom > containerBottom) {
              listContainer.scrollTop += itemBottom - containerBottom;
            } else if (itemTop < containerTop) {
              listContainer.scrollTop -= containerTop - itemTop;
            }
          }
        }
  
        // Handle Up Arrow key (keyCode 38)
        else if (keyCode === 38) {
          event.preventDefault();
  
          const selectElement = drillDownSearch.querySelector('select');
          const visibleItems = Array.from(
            drillDownSearch.querySelectorAll('.drill-down-list .drill-down-list-item') as NodeListOf<HTMLElement>
          ).filter((item) => item.offsetParent !== null);
  
          if (
            selectElement.value <= 0 ||
            selectElement.value === visibleItems[0]?.getAttribute('list-value')
          ) {
            const lastVisibleItem = visibleItems[visibleItems.length - 1];
            selectElement.value = lastVisibleItem?.getAttribute('list-value') || '0';
            drillDownSearch.querySelector('.currentActiveDDITem')?.classList.remove('currentActiveDDITem');
            lastVisibleItem?.classList.add('currentActiveDDITem');
            event.target.value = selectElement.options[selectElement.selectedIndex]?.text || '';
          } else {
            const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
            const prevVisibleItem = Array.from(visibleItems).reverse().find(
              (item) => item === currentActiveItem?.previousElementSibling
            );
  
            if (prevVisibleItem) {
              selectElement.value = prevVisibleItem.getAttribute('list-value');
              event.target.value = selectElement.options[selectElement.selectedIndex]?.text || '';
              currentActiveItem?.classList.remove('currentActiveDDITem');
              prevVisibleItem.classList.add('currentActiveDDITem');
            } else {
              const lastActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
              selectElement.value = lastActiveItem?.getAttribute('list-value') || '0';
              event.target.value = selectElement.options[selectElement.selectedIndex]?.text || '';
              lastActiveItem?.classList.remove('currentActiveDDITem');
              lastActiveItem?.classList.add('currentActiveDDITem');
            }
          }
  
          // Scroll handling
          const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
          const listContainer = drillDownSearch.querySelector('.drill-down-list');
          if (currentActiveItem && listContainer) {
            const itemTop = currentActiveItem.getBoundingClientRect().top;
            const itemBottom = itemTop + currentActiveItem.offsetHeight;
            const containerTop = listContainer.getBoundingClientRect().top;
            const containerBottom = containerTop + listContainer.offsetHeight;
  
            if (itemBottom > containerBottom) {
              listContainer.scrollTop += itemBottom - containerBottom;
            } else if (itemTop < containerTop) {
              listContainer.scrollTop -= containerTop - itemTop;
            }
          }
        }
  
        // Handle other keys
        else {
          const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
          currentActiveItem?.classList.remove('currentActiveDDITem');
  
          const selectElement = drillDownSearch.querySelector('select');
          selectElement.value = '-1';
  
          const ddSearchValue = event.target.value.toLowerCase();
          const listItems = Array.from(
            drillDownSearch.querySelectorAll('.drill-down-list-item') as NodeListOf<HTMLElement>
          );
  
          listItems.forEach((item) => {
            item.innerHTML = item.getAttribute('ogListValue') || '';
            if (item.textContent?.toLowerCase().includes(ddSearchValue)) {
              item.style.display = 'block';
              item.innerHTML = this.highlight(item.innerHTML, ddSearchValue);
            } else {
              item.style.display = 'none';
            }
          });
  
          const visibleItems = listItems.filter((item) => item.offsetParent !== null);
          if (visibleItems.length === 0) {
            drillDownSearch.classList.remove('showDrillList');
          } else {
            drillDownSearch.classList.add('showDrillList');
          }
  
          if (event.target.value !== this.prevValue) {
            this.checkDrillDown = 0;
          } else {
            this.checkDrillDown = 1;
          }
        }
      } else {
        const drillDownSearch = event.target.closest('.drill-down-search');
        drillDownSearch.classList.remove('showDrillList');
      }
    }, 1);
  }

  setPrevValue(event) {
    this.prevValue = event.target.value;
  }

  highlight(s, search) {
    return s.replace(
      new RegExp(search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'),
      '<b>$&</b>',
    );
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  gotoNextQuestion(question: Questions, event) {
    this.service.gotoNextQuestion(question, event);
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }
}
